import { render } from "./AdminSelectGood.vue?vue&type=template&id=193d63a2"
import script from "./AdminSelectGood.vue?vue&type=script&lang=js"
export * from "./AdminSelectGood.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Administrator\\Desktop\\wxPrint2\\adminVue3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__